{
  "menu": {
    "home": "Inicio",
    "companies": "Empresas",
    "sites": "Sedes",
    "admins": "Administradores",
    "audit": "Auditoría",
    "schedules": "Horarios",
    "timesheet": "Tareo",
    "integration": "Integración",
    "integrationBadge": "{count} registros por revisar de la integración",
    "settings": "Configuración",
    "profile": "Perfil",
    "logout": "Cerrar sesión"
  },
  "nav": {
    "label": "Navegación principal",
    "skipToContent": "Ir al contenido"
  },
  "header": {
    "company": "Empresa",
    "admin": "Administrador",
    "panel": "Panel de Fermin"
  },
  "siteSelector": {
    "label": "Sede",
    "all": "Todas las sedes",
    "placeholder": "Elige una sede",
    "empty": "No tienes sedes asignadas."
  },
  "home": {
    "loading": "Cargando…"
  },
  "warnings": {
    "NO_SITES_IN_SCOPE": "No tienes sedes activas asignadas. Pide a tu administrador que te asigne una."
  },
  "sessionError": {
    "title": "No pudimos cargar tu sesión",
    "description": "Revisa tu conexión e inténtalo de nuevo."
  }
}
